import React from 'react';

import "./LoadingSpinner.css"

const LoadingSpinner = ({ asOverlay }) => {
  return (
    <div className={`${asOverlay ? 'loading-spinner__overlay' : ''}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
        className="lds-dual-ring"
        role="img"
        aria-label="Loading"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
          fill="#327acf"
          stroke="none"
        >
          <path d="M2130 3820 c-61 -11 -177 -52 -236 -85 -248 -137 -395 -364 -419 -645 -9 -109 12 -276 45 -355 18 -45 41 -97 57 -131 21 -46 148 -181 222 -236 49 -37 153 -94 216 -118 73 -28 253 -56 267 -42 5 5 7 138 6 297 l-3 290 -49 8 c-64 10 -119 47 -147 97 -62 112 -45 239 40 296 84 55 57 54 1077 54 518 0 952 3 964 8 l24 9 -23 6 c-13 3 -20 10 -17 16 4 5 2 13 -4 16 -8 5 -8 11 0 20 8 9 2 20 -22 44 -17 17 -26 31 -18 31 8 0 4 8 -10 20 -13 11 -19 20 -14 20 5 0 4 4 -1 8 -6 4 -23 27 -39 52 -65 100 -174 220 -273 298 l-41 32 -779 -1 c-428 -1 -798 -5 -823 -9z m2011 -477 c13 -16 12 -17 -3 -4 -17 13 -22 21 -14 21 2 0 10 -8 17 -17z" />
          <path d="M4155 3310 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z" />
          <path d="M2720 2774 c-11 -27 -14 -532 -4 -558 4 -10 18 -16 40 -16 19 0 51 -9 72 -19 89 -46 123 -103 125 -211 1 -69 -1 -81 -26 -117 -15 -22 -46 -50 -70 -64 l-42 -24 -977 -3 -976 -2 7 -28 c40 -136 144 -310 260 -435 125 -133 6 -118 946 -117 804 0 818 1 883 22 252 80 442 256 530 489 25 68 52 220 52 296 0 119 -40 274 -102 398 -19 38 -93 132 -129 165 -93 84 -152 125 -239 166 -101 47 -114 52 -215 70 -112 20 -124 19 -135 -12z" />
        </g>
      </svg>
    </div>
  );
};

export default LoadingSpinner;
